import { useSearchParams } from 'next/navigation'

import { useRequestQuickFilters } from '@/api/models/requests/hooks/useRequestQuickFilters'
import {
  QuickFilterComponent,
  QuickFilterType
} from '@/api/models/requests/lib/requests.types'
import { PageType } from '@/components/entities/requests/model/types'

export const useQuickFiltersByPageType = (pageType: PageType) => {
  const { data: requestQuickFilters } = useRequestQuickFilters()
  const searchParams = useSearchParams()

  if (pageType === PageType.Passes) {
    const params = new URLSearchParams(searchParams?.toString())
    const category = params.get('category')

    if (category) {
      return requestQuickFilters?.filter(({ component }) =>
        category === QuickFilterComponent.PermanentPassMen
          ? component === QuickFilterComponent.PermanentPassMen
          : component === QuickFilterComponent.PermanentPassAuto
      )
    }
    return requestQuickFilters?.filter(
      ({ type, component }) =>
        type === QuickFilterType.Pass &&
        component === QuickFilterComponent.MainList
    )
  }

  if (pageType === PageType.Requests) {
    return requestQuickFilters?.filter(
      ({ type }) => type === QuickFilterType.Common
    )
  }

  return null
}
